import { defineStore } from 'pinia';
import { useApi } from '@lib/api';
import { useGlobalStore } from '@/store/global-store-base';

export const useComponentAttributeTypes = defineStore('component-attribute-types', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.componentAttributeType_ListComponentAttributeTypes,
    dto: 'ComponentAttributeTypeDto',
    create: api.componentAttributeType_CreateComponentAttributeType,
    update: api.componentAttributeType_UpdateComponentAttributeType,
    delete: api.componentAttributeType_DeleteComponentAttributeType,
    signalR: 'ComponentAttributeTypeUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
